// extracted by mini-css-extract-plugin
export default {"map":"gIHLS","variants":"nYGn6","compactVariants":"zTUqt","variant":"vY4ug","compactMap":"xlTrB"};